import phoneMask from './phoneMask';

// @todo remake without use onChange
// @todo allow make self-instance for each input
function mask(event) {
  phoneMask(event);
}
export default mask;
